import { render, staticRenderFns } from "./Ncd.vue?vue&type=template&id=1608b641&"
import script from "./Ncd.vue?vue&type=script&lang=js&"
export * from "./Ncd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports